import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { trackPageView } from './utils/metrika';
import { useRouteSeo } from './utils/seo';
import { prefetchConfiguratorAssets } from './utils/prefetchConfigurator';
import Home from './pages/Home';
import ConfiguratorPage from './pages/ConfiguratorPage';
import CartPage from './pages/CartPage';
import PrivacyPage from './pages/PrivacyPage';
import CookieNotice from './components/CookieNotice';
import Cases from './pages/Cases';
import Certificates from './pages/Certificates';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function MetrikaTracker() {
  const location = useLocation();
  useRouteSeo();
  useEffect(() => {
    trackPageView();
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  useEffect(() => {
    prefetchConfiguratorAssets();
  }, []);

  return (
    <BrowserRouter>
      <MetrikaTracker />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/configurator" element={<ConfiguratorPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </div>
      <CookieNotice />
    </BrowserRouter>
  );
}

export default App;
